export const TEST_SUMMARY_ACTIONS = {
  'SET_FINAL': '[Test Summary] SET_FINAL',
  'SET_ADDENDUM': '[Test Summary] SET_ADDENDUM',
  'INIT_REVIEWS': '[Test Summary] INIT_REVIEWS',
  'SET_STATE': '[Test Summary] SET_STATE',
  'SET_SUMMARIES': '[Test Summary] SET_SUMMARIES'
};
